import { useEffect, useRef } from 'react';
import { getCustomerDetailsByIdAction } from '../../../redux/actions/customerDetailsAction';
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { formatPhoneNumber } from '../../../common/helpers/commonFun';

const CustomerDetail = ({clientCustomerId, data}) => {
    const dispatch = useDispatch();
    const customerDetailsFromRedux = useSelector(state => state?.customerDetails?.selectedCustomer || null);
    const fetchedOnce = useRef(false);

    const view = data ?? customerDetailsFromRedux;
    
    useEffect(() => {
        if (data || !clientCustomerId || fetchedOnce.current) return;
        fetchedOnce.current = true;
        dispatch(getCustomerDetailsByIdAction(clientCustomerId));
    }, [clientCustomerId, data, dispatch]);

    return(
        <>
            <Table sx={{ verticalAlign: "Top", padding: "0 10px" , boxShadow: "none", backgroundColor: "#ffffff", }}>
                <TableBody>
                    <TableRow sx={{ verticalAlign: "Top" }}>
                        <TableCell>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                        <strong>First Name:</strong>
                                        </TableCell>
                                        <TableCell>
                                        {view?.firstName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                        <strong>Middle Name:</strong>
                                        </TableCell>
                                        <TableCell>
                                        {view?.middleName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                        <strong>Last Name:</strong>
                                        </TableCell>
                                        <TableCell>
                                        {view?.lastName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                        <strong>ZipCode:</strong>
                                        </TableCell>
                                        <TableCell>
                                        {view?.zipCode}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableCell>

                        <TableCell>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                        <strong>Date of Birth:</strong>
                                        </TableCell>
                                        <TableCell>
                                        {view?.dateOfBirth}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                        <strong>Email:</strong>
                                        </TableCell>
                                        <TableCell>{view?.email}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                        <strong>Phone Number:</strong>
                                        </TableCell>
                                        <TableCell>
                                        {formatPhoneNumber(view?.phoneNumber)}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableCell>
                        <TableCell>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                        <strong>Address:</strong>
                                        </TableCell>
                                        <TableCell>
                                        {view?.addressLine1}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                        <strong>Citydd:</strong>
                                        </TableCell>
                                        <TableCell>{view?.city}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                        <strong>State:</strong>
                                        </TableCell>
                                        <TableCell>{view?.state}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    )
}
export default CustomerDetail;